<template>
    <transition tag="div" name="shrink">
        <p
            v-if="fieldValidation.$error"
            class="mt-2 text-red-500 tiny"
            style="
                 {
                    maxheight: '200px';
                }
            "
        >
            {{ errors[0] }}
        </p>
    </transition>
</template>

<script>
export default {
    props: {
        fieldValidation: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            messages: {
                default: () => 'Please enter a valid input',
                required: () => 'Please enter a value',
                validPhoneNumber: () => 'Please enter a valid phone number, eg. 0412341234',
                validDob: () => 'Please enter a valid DOB, eg. 29/08/1992'
            }
        };
    },

    computed: {
        errors() {
            return this.checkErrors(this.fieldValidation);
        }
    },

    methods: {
        checkErrors(validationObj) {
            return Object.keys(validationObj.$params).reduce((errors, check) => {
                const status = validationObj[check];
                if (typeof status === 'object') return [...errors, ...this.checkErrors(status)];
                if (status) return errors;

                const currentValue = validationObj.$model;
                const errorTemplate = this.messages[check] || this.messages.default;
                return [...errors, errorTemplate(currentValue)];
            }, []);
        }
    }
};
</script>
